import React from "react";
import { Link } from "gatsby";
import { library, config } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import "./layout.scss";
import "@fortawesome/fontawesome-svg-core/styles.css"; // Setup Font Awesome
config.autoAddCss = false;
library.add(fas);
var Layout = function Layout(props) {
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("main", {
        className: "container-fluid"
    }, props.children), /*#__PURE__*/ React.createElement("footer", {
        className: "container-fluid mb-5"
    }, /*#__PURE__*/ React.createElement("hr", null), /*#__PURE__*/ React.createElement("span", {
        className: "text-muted"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/"
    }, "top")), /*#__PURE__*/ React.createElement("span", {
        className: "text-muted mx-3"
    }, "\u2014"), /*#__PURE__*/ React.createElement("span", {
        className: "text-muted"
    }, "Please email questions or comments to", " ", /*#__PURE__*/ React.createElement("a", {
        href: "mailto:poe@poepoe.org"
    }, "poe@poepoe.org"), ".")));
};
export default Layout;
